<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-3.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            i.fa.fa-search
          DebounceInput(autofocus type="text" v-model="searchID" :placeholder="$t('message.search_by_operator')" @enter="getOperatorList(true)" size="sm")
      .form-group.col-6.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getOperatorList(true)"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="10%" @click="sortOrder('account_id')")
                  span(:ttile="$t('ui.account_id')") {{ $t('ui.account_id') }}
                  .float-right
                    i(:class="changeSortKey('account_id')")
                th(width="10%" @click="sortOrder('profile_id')")
                  span(:title="$t('ui.profile_id')") {{ $t('ui.profile_id') }}
                  .float-right
                    i(:class="changeSortKey('profile_id')")
                th(width="12%" @click="sortOrder('full_name')")
                  span(:title="$t('ui.full_name')") {{ $t("ui.full_name") }}
                  .float-right
                    i(:class="changeSortKey('full_name')")
                th(width="10%" @click="sortOrder('contact_phone')")
                  span(:title="$t('ui.contact_phone')") {{ $t("ui.contact_phone") }}
                  .float-right
                    i(:class="changeSortKey('contact_phone')")
                th(width="10%" @click="sortOrder('contact_email')")
                  span(:title="$t('ui.contact_email')") {{ $t("ui.contact_email") }}
                  .float-right
                    i(:class="changeSortKey('contact_email')")
                th(width="10%")
                  span(:title="$t('ui.login_ip')") {{ $t("ui.login_ip") }}
                th.text-center(width="8%")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                th.text-right(width="15%" @click="sortOrder('created_date')")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                  i(:class="changeSortKey('created_date')")
            tbody.clusterize-content
              tr(v-if="operatorList.length == 0")
                td(colspan="10").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in operatorList" :class="$helpers.rowClass(item)")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.account_id")
                    a.text-decoration-none(href="javascript:void(0)" @click="setOperatorID(item)" :title="$t('ui.combine.edit_operator')") {{ item.account_id }}
                td
                  span(:title="item.profile_id") {{ item.profile_id }}
                td
                  span(:title="item.full_name") {{ item.full_name }}
                td
                  span(:title="item.contact_phone") {{ item.contact_phone }}
                td
                  span(:title="item.contact_email") {{ item.contact_email }}
                td
                  span(:title="item.last_login_ip") {{ item.last_login_ip }}
                td.text-center
                  span(:title="item.status" :class="$helpers.badgeClass(item.status)") {{ item.status }}
                td.text-right
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    operatorList: [],
    operatorDetail: null,
    currentPage: 1,
    totalRow: 0,
    searchID: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedOperator: null,
    currOperator: null,
    sortKey: "account_id",
    sortType: "asc",
    filterBy: "account_id"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_ticketlistopvoucher");
    }
  },
  mounted: function() {
    if(this.operatorID) {
      this.searchID = this.operatorID
    }

    this.getOperatorList(true);
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getOperatorList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    setOperatorID: function(e) {
      this.$store.dispatch("user/setSelectedOperatorID", e.account_id);
      this.$emit('changeLayer', 2)
    },
    getOperatorList: function(isSearch, clearSearch) {
      let url = config.accountListUrl();

      if (isSearch) this.currentPage = 1;
      if (clearSearch) this.searchID = "";;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        login_id: this.$store.getters.loginId,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize,
        search_account_type: 2
      };

      if (this.searchID.trim() != '')
        json.search_account_id = this.searchID;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.operatorList = response.data.dt;
                this.totalRow = this.operatorList.length > 0 ? this.operatorList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getOperatorList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getOperatorList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>